import { getStoreState } from 'config/store'
import { DEMANDBASE_COOKIE } from 'shared/constants/cookies'

import { isIntegrationIdentityEnabled } from '../selectors'

const DemandbaseIdentityProvider = {
  identify: (cookies: Record<string, any> = {}) => {
    return cookies[DEMANDBASE_COOKIE]
  },
  getIdentityEnabled: () => isIntegrationIdentityEnabled(getStoreState(), 'demandbase'),
  getIntegrationContext: (cookies: Record<string, any> = {}) => {
    return !!cookies[DEMANDBASE_COOKIE]
      ? {
          demandbase: { cookie: cookies[DEMANDBASE_COOKIE] }
        }
      : {}
  }
}

export default DemandbaseIdentityProvider
